// extracted by mini-css-extract-plugin
export default {"name":"Header_name__U2q0p","code":"Header_code__zJdQ1","item":"Header_item__2kacb"};